import { render, staticRenderFns } from "./jdorder.vue?vue&type=template&id=2876123e&"
import script from "./jdorder.vue?vue&type=script&lang=js&"
export * from "./jdorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports